export const webAppVersion = '2.2.8';
